import {
  SIDE_NAV_LIGHT,
  NAV_TYPE_SIDE,
  DIR_LTR,
} from "constants/ThemeConstant";
import { env } from "./EnvironmentConfig";

export const APP_NAME = process.env.REACT_APP_SITE_NAME;
export const VAPID_KEY =
  "BD7AHxoaLKaktuOF8r-2r51YwqLvtyXhcGXIThYk5ukHPhfsTE2t8gDK-D1CBuS-OaDIU5CMVQpzIfUbtcRnUpc";
export const API_BASE_URL = env.API_ENDPOINT_URL;
export const APP_PREFIX_PATH = "/app";
export const AUTH_PREFIX_PATH = "/auth";
export const AUTH_TOKEN = "auth_token";
export const REDIRECT_URL_KEY = "redirect";
export const AUTHENTICATED_ENTRY = `${APP_PREFIX_PATH}/dashboards/default`; //default page in dashboard
export const UNAUTHENTICATED_ENTRY = "/login";
export const REDIRECT_COMPONENT_KEY = "dashboard";
export const LOGO_IMAGE = `/img/logo/${process.env.REACT_APP_CLIENT_NAME}/logo.svg`;

/** Per-client feature flags (keyed by REACT_APP_CLIENT_NAME) */
export const CLIENT_CONFIGS = {
  ecommerce: {
    regionDeliverCharge: false,
    policyEditorPrimaryBg: false,
  },
  maev: {
    regionDeliverCharge: false,
    policyEditorPrimaryBg: false,
  },
  natanki: {
    regionDeliverCharge: false,
    policyEditorPrimaryBg: false,
  },
  paars: {
    regionDeliverCharge: false,
    policyEditorPrimaryBg: false,
  },
  fika: {
    regionDeliverCharge: false,
    policyEditorPrimaryBg: false,
  },
  oneira: {
    regionDeliverCharge: false,
    policyEditorPrimaryBg: false,
  },
  ira: {
    regionDeliverCharge: false,
    policyEditorPrimaryBg: false,
  },
  kaka: {
    regionDeliverCharge: false,
    policyEditorPrimaryBg: true,
  },
  seraph: {
    regionDeliverCharge: false,
    policyEditorPrimaryBg: false,
  },
  lanzanehub: {
    regionDeliverCharge: false,
    policyEditorPrimaryBg: false,
  },
  knotikids: {
    regionDeliverCharge: false,
    policyEditorPrimaryBg: false,
  },
  knotikidstest: {
    regionDeliverCharge: false,
    policyEditorPrimaryBg: false,
  },
  ylaonline: {
    regionDeliverCharge: false,
    policyEditorPrimaryBg: false,
  },
  zibacollections: {
    regionDeliverCharge: false,
    policyEditorPrimaryBg: false,
  },
  Maskhari: {
    regionDeliverCharge: false,
    policyEditorPrimaryBg: false,
  },
};

export const getClientConfig = () => {
  const client = process.env.REACT_APP_CLIENT_NAME;
  return (
    CLIENT_CONFIGS[client] || {
      regionDeliverCharge: false,
      policyEditorPrimaryBg: false,
    }
  );
};

export const THEME_CONFIG = {
  navCollapsed: false,
  sideNavTheme: SIDE_NAV_LIGHT,
  locale: "en",
  navType: NAV_TYPE_SIDE,
  topNavColor: "#3e82f7",
  headerNavColor: "",
  mobileNav: false,
  currentTheme: "light",
  direction: DIR_LTR,
  blankLayout: false,
};
// in emilus template > setting icon in navbar > select parameters like 'Header Nav Color', 'Dark Theme',
// 'Side Nav Color', 'Navigation Type' etc > click 'Copy Setting' and paste the value in 'THEME_CONFIG'.
